export const OFFER_LISTING_PROMOTION_TAB_LABELS = {
    all: "Wszystkie oferty",
    promotions: "Promocyjne"
} as const;

export const OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID = "promotion_tab_listing";

export type OfferListingPromotionTab = keyof typeof OFFER_LISTING_PROMOTION_TAB_LABELS;
export const OFFER_LISTING_PROMOTION_TAB_LABELS = {
    all: "Wszystkie oferty",
    promotions: "Promocyjne"
} as const;

export const OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID = "promotion_tab_listing";

export type OfferListingPromotionTab = keyof typeof OFFER_LISTING_PROMOTION_TAB_LABELS;
